import React from "react"

import VideoInline from "../videoInline"
import VideoPlayer from "../videoPlayer"
import styles from "./video.styles.scss"

const Video = props => {
  const columns = props.data.columnWidth
  const autoplay = props.data.autoplay
  const wrapperWidth = columns === "14" ? "no-padding-wrapper" : ""
  const columnMargin = columns === "14" ? "no-margin-col" : ""

  const attrs = {
    src: props.data.video[0].url,
    type: props.data.video[0].mimeType,
    poster: props.data.posterImage ? props.data.posterImage[0].url : null,
  }

  return (
    <div className="module module--image">
      <div className={`wrapper ${wrapperWidth}`}>
        <div className={`columns is-centered ${columnMargin}`}>
          <div className={`column is-${columns}-desktop video-mask`}>
            {autoplay ? <VideoInline {...attrs} /> : <VideoPlayer {...attrs} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Video
